// The round ✕ that closes a card, list or panel (web/style.css .close).
import type { MouseEvent } from "react";
import { T } from "../shared/config";
import { Icon } from "../shared/icons";
import styles from "./buttons.module.css";

export function CloseButton({ onClick, id }: { onClick: (ev: MouseEvent) => void; id?: string }) {
  return <button type="button" id={id} className={styles.close} aria-label={T("close")} title={T("close")} onClick={onClick}><Icon name="x" /></button>;
}
